import { render, staticRenderFns } from "./AssignCourses.vue?vue&type=template&id=4576b069"
import script from "./AssignCourses.vue?vue&type=script&lang=js"
export * from "./AssignCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports